<div class="b-f-attendees">
  <label *ngIf="props.altLabel" [for]="field.id">{{ props.altLabel }}</label>
  <p-autoComplete
    #autoComplete
    [formControl]="formControl"
    [formlyAttributes]="field"
    [suggestions]="results"
    [multiple]="true"
    [scrollHeight]="props.scrollHeight ?? '50vh'"
    [completeOnFocus]="true"
    [style]="props.style ?? ''"
    [styleClass]="props.styleClass ?? ''"
    [inputId]="field.id"
    [placeholder]="props.placeholder ?? null"
    [readonly]="props.readonly ?? false"
    [appendTo]="props.appendTo ?? ''"
    (completeMethod)="search($event)"
    (click)="openDropdown($event)"
  >
    <ng-template let-user pTemplate="item">
      <basin-list-item
        [primaryLine]="user.firstName + ' ' + user.lastName"
        class="b-f-attendees-user"
      >
        <p-avatar
          leftSection
          *ngIf="user.userProfileImage"
          shape="circle"
          [image]="user.userProfileImage"
        ></p-avatar>
        <p-avatar
          leftSection
          *ngIf="!user.userProfileImage"
          shape="circle"
          [label]="getUserInitials(user.firstName, user.lastName)"
        ></p-avatar>
      </basin-list-item>
    </ng-template>
    <ng-template let-selectedUser pTemplate="selectedItem">
      <span
        [class.user-clicked]="selectedUser == selectedUserSelected"
        (click)="selectedUserClicked(selectedUser)"
      >
        {{ selectedUser.firstName + ' ' + selectedUser.lastName }};
      </span>
    </ng-template>
  </p-autoComplete>
</div>
